import React, {Component} from 'react';
import {
  withRouter, Link
} from 'react-router-dom';
import {connect} from 'react-redux';
import styled from 'styled-components';


// CSS
import style from "../../Styles/Components/CheckList.module.css";

//component
import CheckItem from "./CheckItem";

const EtcInput = styled.input.attrs((props) => ({
    disabled: props.disabled || false
}))`
        width: 100%;
        height: 100%;
        background-color: #f8f8f8;
        font-size: 14px;
        outline: none;
        border: none;
        border-bottom: 1px solid #ccc;
        color: ${props => props.disabled ? '#ccc' : '#555'};
        padding: 20px 8px;
        box-sizing: border-box;
        
        ::placeholder {
            color: #aaa;
        }
    `

function CheckList({ list, feedSelectText, customRenderCheckItem = null, bottomContents, onChange }) {


    const renderCheckItem = customRenderCheckItem ? customRenderCheckItem : (list) => {
        return  (list || []).map((item, idx) => {
            return <CheckItem onClick={(idx) => item.onClick(idx)} key={idx} id={idx} title={item.title} isChecked={item.isChecked}/>
        })
    }

    return (
        <ul className={style.list}>
            {renderCheckItem(list)}
            { bottomContents ? bottomContents : null }
        </ul>
    )
}


export default CheckList;